// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"3dd574b7","408":"0dc4abb0","488":"462adc51"}[chunkId] + ".chunk.js";
};